/**
 * Copyright 2023 The Ground Authors.
 *
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  MatButtonToggle,
  MatButtonToggleGroup,
} from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';

import { EditJobComponent } from 'app/components/edit-survey/edit-job/edit-job.component';
import { JobIntegrationEditorModule } from 'app/components/shared/job-integration-editor/job-integration-editor.module';
import { LoiEditorModule } from 'app/components/shared/loi-editor/loi-editor.module';
import { TaskEditorModule } from 'app/components/shared/task-editor/task-editor.module';

@NgModule({
  declarations: [EditJobComponent],
  imports: [
    CommonModule,
    MatButtonToggleGroup,
    MatButtonToggle,
    MatIconModule,
    JobIntegrationEditorModule,
    LoiEditorModule,
    TaskEditorModule,
  ],
  exports: [EditJobComponent],
})
export class EditJobModule {}
